import React from "react";
import { useGetSathiDetailsbyIdQuery } from "../SaathiApiSlice";
import { Col, Row } from "react-bootstrap";
import { CardHeader, Input, Label } from "reactstrap";
import SaathiDocuments from "../SaathiDocuments";

const PreviewSaathiDetails = () => {
  const id = localStorage.getItem("applicant_id");

  const {
    data: data,
    refetch: SaathiDetailsRefetch,
  } = useGetSathiDetailsbyIdQuery(id);

  const SaathiUserData = data?.data;

  const experienceLabels = {
    "1": "Insurance",
    "2": "Banking",
    "3": "Agri Input",
    "4": "Agri Output",
  };

  const experienceFieldValues =
    SaathiUserData?.business_details?.experiences?.experience_fields
      ?.map((id) => experienceLabels[id])
      .filter(Boolean) || [];

  return (
    <div
      className="p-2 d-flex flex-column gap-3"
      style={{
        height: "93vh",
        overflowY: "auto",
        backgroundColor: "#fff",
        borderRadius: "8px",
      }}
    >
      {/* Basic details */}
      <div>
        <CardHeader
          style={{ padding: "13px" }}
          className=" mb-3 d-flex justify-content-between align-items-center"
        >
          <h5 className="m-0 text-primary ">Personal Details </h5>
        </CardHeader>

        <Row className="mb-3">
          <Col lg="3" className="mb-2">
            <Label>Entity Type</Label>
            <Input
              name=""
              defaultValue={SaathiUserData?.personal_details?.individuals}
              disabled
              className="fs-6 rounded-2 text-capitalize"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>First Name</Label>
            <Input
              name="firstName"
              defaultValue={SaathiUserData?.firstName}
              disabled
              className="fs-6 rounded-2 text-capitalize"
            />
          </Col>
          <Col lg="3" className="mb-2">
            <Label>Last Name</Label>
            <Input
              name="lastName"
              defaultValue={SaathiUserData?.lastName}
              disabled
              className="fs-6 rounded-2 text-capitalize"
            />
          </Col>
          <Col lg="3" className="mb-2">
            <Label>Phone No.</Label>
            <Input
              name=""
              defaultValue={SaathiUserData?.phoneNumber}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>
          <Col lg="3" className="mb-2">
            <Label>Alternate Phone Number</Label>
            <Input
              name="alternatePhoneNumber"
              defaultValue={
                SaathiUserData?.personal_details?.alternatePhoneNumber
              }
              type="number"
              disabled
              className="fs-6 rounded-2"
            />
          </Col>
          <Col lg="3" className="mb-2">
            <Label>Email</Label>
            <Input
              name="email"
              type="email"
              defaultValue={SaathiUserData?.email}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>
          <Col lg="3" className="mb-2">
            <Label>Highest Qualification</Label>
            <Input
              defaultValue={
                SaathiUserData?.education_details?.highest_qualification
              }
              disabled
              className="fs-6 rounded-2 text-capitalize"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>Passing Year</Label>
            <Input
              defaultValue={SaathiUserData?.education_details?.year_of_passing}
              disabled
              className="fs-6 rounded-2 text-capitalize"
            />
          </Col>
        </Row>
      </div>

      {/* kyc details */}
      <div>
        <CardHeader
          style={{ padding: "13px" }}
          className=" mb-3 d-flex justify-content-between align-items-center"
        >
          <h5 className="m-0 text-primary">KYC Details </h5>
        </CardHeader>
        <Row>
          <Col lg="3" className="mb-2">
            <Label>Gender</Label>
            <Input
              defaultValue={SaathiUserData?.personal_details?.gender}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>Date of Birth</Label>
            <Input
              defaultValue={SaathiUserData?.personal_details?.dateOfBirth}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>Martial Status</Label>
            <Input
              defaultValue={SaathiUserData?.personal_details?.martialStatus}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>Nominee Name</Label>
            <Input
              defaultValue={SaathiUserData?.personal_details?.nomineeName}
              disabled
              className="fs-6 rounded-2 text-capitalize"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>Nominee Relationship</Label>
            <Input
              defaultValue={
                SaathiUserData?.personal_details?.nomineeRelationship
              }
              disabled
              className="fs-6 rounded-2"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>No of Member</Label>
            <Input
              defaultValue={SaathiUserData?.personal_details?.noOfMember}
              disabled
              className="fs-6 rounded-2"
              maxLength="2"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>Occupation</Label>
            <Input
              defaultValue={SaathiUserData?.personal_details?.occupation}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>Aadhar Number</Label>
            <Input
              defaultValue={SaathiUserData?.personal_details?.aadharNumber}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>Pan Number</Label>
            <Input
              defaultValue={SaathiUserData?.personal_details?.panNumber}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>State</Label>
            <Input
              defaultValue={SaathiUserData?.personal_details?.state}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>District</Label>
            <Input
              defaultValue={SaathiUserData?.personal_details?.district}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>Block</Label>
            <Input
              defaultValue={SaathiUserData?.personal_details?.city}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>Address</Label>
            <Input
              defaultValue={SaathiUserData?.personal_details?.address}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>Pincode</Label>
            <Input
              defaultValue={SaathiUserData?.personal_details?.pincode}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>
        </Row>
      </div>

      {/* Bank Details  */}
      <div>
        <CardHeader
          style={{ padding: "13px" }}
          className=" mb-3 d-flex justify-content-between align-items-center"
        >
          <h5 className="m-0 text-primary">Bank Details </h5>
        </CardHeader>

        <Row className="mb-3">
          <Col lg="3" className="mb-2">
            <Label>Account Holder Name</Label>
            <Input
              defaultValue={SaathiUserData?.bank_details?.account_holder_name}
              disabled
              className="fs-6 rounded-2 text-capitalize"
            />
          </Col>

          <Col lg="3" className="mb-2">
            <Label>Account Number</Label>
            <Input
              defaultValue={SaathiUserData?.bank_details?.account_number}
              disabled
              className="fs-6 rounded-2 text-capitalize"
            />
          </Col>
          <Col lg="3" className="mb-2">
            <Label>Account Type</Label>
            <Input
              defaultValue={SaathiUserData?.bank_details?.account_type}
              disabled
              className="fs-6 rounded-2 text-capitalize"
            />
          </Col>
          <Col lg="3" className="mb-2">
            <Label>IFSC Code</Label>
            <Input
              defaultValue={SaathiUserData?.bank_details?.ifsc_code}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>
          <Col lg="3" className="mb-2">
            <Label>Bank Name</Label>
            <Input
              defaultValue={SaathiUserData?.bank_details?.bank_name}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>
          <Col lg="3" className="mb-2">
            <Label>Branch Name</Label>
            <Input
              defaultValue={SaathiUserData?.bank_details?.bank_branch}
              disabled
              className="fs-6 rounded-2"
            />
          </Col>
        </Row>
      </div>

      {/* Business & Certication  */}
      <div>
        <CardHeader
          style={{ padding: "13px" }}
          className=" mb-3 d-flex justify-content-between align-items-center"
        >
          <h5 className="m-0 text-primary">Business & Certification Details</h5>
        </CardHeader>
        <Row className="mb-2">
          <Col lg="3" className="mb-3">
            <Label>Primary Source of Income</Label>
            <Input
              value={SaathiUserData?.business_details?.income_source}
              disabled
              className="  rounded-2 text-capitalize"
            />
          </Col>

          <Col lg={3} className="text_box mb-3">
            <Label className="f_p text_c f_400">Income</Label>
            <Input
              value={SaathiUserData?.business_details?.income}
              disabled
              className="  rounded-2"
            />
          </Col>

          <Col lg={4} className="mb-3">
            <Label className="f_p text_c f_400">Experience In</Label>

            <div className="d-flex flex-wrap gap-3">
              <Input
                value={experienceFieldValues.join(", ")}
                disabled
                className="rounded-2"
              />
            </div>
          </Col>

          <Col lg={3} className="mb-3">
            <Label className="f_p text_c f_400">
              Professional Training (Insurance/Banking)
            </Label>
            <Input
              value={
                SaathiUserData?.business_details
                  ?.is_professional_training_insurance_and_bank_product
                  ? "Yes"
                  : "No"
              }
              disabled
              className="form-control  rounded-2"
            />
          </Col>

          <Col lg={3} className="mb-3">
            <Label className="f_p text_c f_400">Interested in Selling</Label>
            <Input
              value={SaathiUserData?.business_details?.interest_in_selling}
              disabled
              className="form-control  rounded-2 text-capitalize"
            />
          </Col>

          <Col lg={3} className="mb-3">
            <Label className="f_p text_c f_400">Insurance Exam Passed ?</Label>
            <Input
              value={
                SaathiUserData?.certification_details
                  ?.is_insurance_exam_passed === true
                  ? "Yes"
                  : "No"
              }
              disabled
              className="form-control  rounded-2 text-capitalize"
            />
          </Col>
          <Col lg={3} className="mb-3">
            <Label className="f_p text_c f_400">Bank Exam Passed ?</Label>
            <Input
              value={
                SaathiUserData?.certification_details
                  ?.is_banking_exam_passed === true
                  ? "Yes"
                  : "No"
              }
              disabled
              className="form-control  rounded-2 text-capitalize"
            />
          </Col>
        </Row>
      </div>

      {/* Documents  */}

      <div>
        <CardHeader
          style={{ padding: "13px" }}
          className=" mb-3 d-flex justify-content-between align-items-center"
        >
          <h5 className="m-0 text-primary">Documents</h5>
        </CardHeader>
        <Row>
          <SaathiDocuments SaathiUserData={SaathiUserData} />
        </Row>
      </div>
    </div>
  );
};

export default PreviewSaathiDetails;
